import { Badge, Group, GroupProps, Text } from '@mantine/core';
import { z } from 'zod';
import { FormatBadge } from '../../components/table/atoms/FormatBadge';

interface NameValuePairProps extends GroupProps {
  name: string;
  value?: string | string[] | number | number[] | boolean;
}

const StringArraySchema = z.string().array();

const transformDataValue = (value: any) => {
  if (typeof value === 'boolean') {
    return <YesNoBadge value={value} />;
  }

  if (StringArraySchema.safeParse(value).success) {
    return <MultipleBadges values={value} />;
  }
  let textValue: string | undefined;
  if (typeof value === 'object' && value.length === 3) {
    textValue = value.map((size: number) => size.toFixed(2)).join(' x ') + ' m';
  }
  if (typeof value === 'number' && value >= 1000) {
    textValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return <Text size='sm'>{textValue ?? value}</Text>;
};

export function NameValuePair({ name, value, ...props }: NameValuePairProps) {
  return (
    <Group justify='space-between' {...props} wrap='nowrap'>
      <Text c='gray.6' size='sm'>
        {name}
      </Text>
      {transformDataValue(value)}
    </Group>
  );
}

function YesNoBadge({ value }: { value: boolean }) {
  if (value) {
    return (
      <Badge color='cyan.0' p='xs' c='black' radius='md'>
        YES
      </Badge>
    );
  }

  return (
    <Badge color='red.0' p='xs' c='black' radius='md'>
      NO
    </Badge>
  );
}

function MultipleBadges({ values }: { values: string[] }) {
  return (
    <Group gap='xs'>
      {values.map((item, index) => (
        <FormatBadge key={`${item}_${index}`}>
          <Text size='sm'>{'.' + item} </Text>
        </FormatBadge>
      ))}
    </Group>
  );
}
